module.exports = __webpack_public_path__ + "img/faq_banner.55e562d9.jpg";